import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { LOGOS_URL } from '../../config';
import useApi from '../../hooks/useApi';
import icon from '../../assets/default.jpg';
//
// Сначала мы делали запрос архива и актуальных выставок по очереди
// по запросу. Но клиент попросил не рисовать кнопку "архив" если
// архива нет, поэтому стали запрашивать сразу все.
//
const HomeAdmin = ({ user }) => {
    const navigate = useNavigate();
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [ events, setEvents ] = useState([]);
    const [ showArchive, setShowArchive ] = useState(false);
    const [ paramsActual, setParamsActual ] = useState({ admin: user._id, archived: false });
    const [ paramsArchive, setParamsArchive ] = useState({ admin: user._id, archived: true });
	const [ actual, errorActual, isLoadingActual ] = useApi({ type: 'get', method: '/eventsbyadmin', params: paramsActual });
	const [ archive, errorArchive, isLoadingArchive ] = useApi({ type: 'get', method: '/eventsbyadmin', params: paramsArchive });

    useEffect(() => {
        setParamsActual({ admin: user._id, archived: false });
        setParamsArchive({ admin: user._id, archived: true });
    }, [ user ]);

    useEffect(() => {
        if(showArchive) setEvents(archive?.events ?? []); else setEvents(actual?.events ?? []);
    }, [ showArchive, actual, archive ]);

	return (
    <div>
        <h1>{showArchive ? t('home.archive') : t('home.myevents')}</h1>
        {(errorActual || errorArchive) && <div className='error'>{t(errorActual || errorArchive)}</div>}
        {(isLoadingActual || isLoadingArchive) && <div>{t('common.loading')}</div>}

        {events.length ?
        <React.Fragment>
            <div className='grid'>
            {events.map(event => (
                <div
                    key={event._id}
                    className='item' onClick={() => navigate('/cabinet/eventview/' + event._id)}
                >
                    <img
                        alt='icon'
                        className='icon'
                        src={event.logo ? LOGOS_URL + event.logo.base + event.logo.name : icon}
                    />
                    <div className='text'>{event.name[lang]}</div>
                </div>
            ))}
            </div> 
        </React.Fragment> : <p>{t('home.noevents')}</p>}

        {archive?.events?.length > 0 && <>
            {showArchive
            ? <div className='ButtonSolid' onClick={() => setShowArchive(false)}>{t('home.myevents')}</div>
            : <div className='ButtonSolid' onClick={() => setShowArchive(true)}>{t('home.archive')}</div>}
        </>}

    </div>
	);
};

HomeAdmin.propTypes = {
    user: PropTypes.object.isRequired,
};

export default HomeAdmin;
